// import React, { useEffect, useState } from 'react';
// import {
//   Card,
//   CardBody,
//   Row,
//   Col,
//   Label,
//   Input,
//   Table,
//   Spinner,
//   Alert,
//   Button,
// } from 'reactstrap';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { apiService } from '../../constants/ApiService';
// import { toast } from 'react-toastify';

// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import VendorBranchSelector from '../../components/VendorBranchSelector';

// const MULTI_PURPOSE_API_GET_ALL =
//   'api/Multi_Purpose_Type_Master/Get_All_Multi_Purpose_Type_Master';

// const EmployeeAttendanceListPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.authState);

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const todayStr = new Date().toISOString().split('T')[0];
//   const maxDate = new Date().toISOString().split('T')[0];

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const [errorMessage, setErrorMessage] = useState({});
//   const [search, setSearch] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [presentMap, setPresentMap] = useState({});
//   const [reasonMap, setReasonMap] = useState({});
//   const [reasonList, setReasonList] = useState([]);

//   const [loadingEmployees, setLoadingEmployees] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [viewLoading, setViewLoading] = useState(false);
//   const [loadingReasons, setLoadingReasons] = useState(false);

//   const [attendanceSummary, setAttendanceSummary] = useState(null);
//   const [error, setError] = useState('');
//   const [successMsg, setSuccessMsg] = useState('');

//   const [attDate, setAttDate] = useState(todayStr);
//   const [startTime, setStartTime] = useState('');
//   const [endTime, setEndTime] = useState('');

//   const getEmployeeId = (x) =>
//     x?.employeeId ?? x?.employee_id ?? x?.EmployeeId ?? null;

//   useEffect(() => {
//     const st = location.state ?? {};
//     const incomingDate = st?.date ?? todayStr;

//     setAttDate(incomingDate > maxDate ? maxDate : incomingDate);
//     setStartTime(st?.startTime ?? '');
//     setEndTime(st?.endTime ?? '');
//     setSelectionData({
//       vendor_id: st?.vendorId ?? '',
//       branch_id: st?.branchId ?? '',
//     });

//     if (Array.isArray(st?.reasonList) && st.reasonList.length > 0) {
//       setReasonList(st.reasonList);
//     }
//   }, [location.state, todayStr, maxDate]);

//   const Get_All_Multi_Purpose_Type_Master = async () => {
//     try {
//       setLoadingReasons(true);

//       const config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       const response = await apiService.get(MULTI_PURPOSE_API_GET_ALL, config);

//       if (response?.response?.data?.errors) {
//         toast.error(response.response.data.errors);
//       }

//       if (response.status === true) {
//         const all = response.data || [];

//         const reasons = all.filter(
//           (item) =>
//             String(item.multi_purpose_flag || '').toLowerCase() ===
//             'attendancereason',
//         );

//         setReasonList(reasons);
//       } else {
//         setReasonList([]);
//         toast.error(response.message || 'Unable to load attendance reasons');
//       }
//     } catch (error) {
//       console.log(error);
//       setReasonList([]);
//       toast.error('SomeThing went wrong while loading reasons!!');
//     } finally {
//       setLoadingReasons(false);
//     }
//   };

//   useEffect(() => {
//     Get_All_Multi_Purpose_Type_Master();
//   }, []);

//   const GetEmployeesList = async (searchText = '', dateParam = null) => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';
//       const usedDate = dateParam ?? attDate;

//       setLoadingEmployees(true);
//       setError('');
//       setSuccessMsg('');
//       setAttendanceSummary(null);

//       const response = await apiService.get(
//         `api/AttendanceMaster/GetEmployeesForAttendance?date=${usedDate}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(searchText || '')}`,
//       );

//       if (response.status === true) {
//         const list = response.data || [];
//         setEmployees(list);

//         const pMap = {};
//         const rMap = {};

//         (list || []).forEach((e) => {
//           const id = getEmployeeId(e);
//           const present = e.isPresent ?? true;

//           if (id != null) {
//             pMap[id] = !!present;
//             if (e.reason) {
//               rMap[id] = e.reason;
//             }
//           }
//         });

//         setPresentMap(pMap);
//         setReasonMap(rMap);
//       } else {
//         setEmployees([]);
//         setPresentMap({});
//         setReasonMap({});
//         toast.error(response.message || 'Unable to load employees');
//       }
//     } catch (err) {
//       console.log(err);
//       setEmployees([]);
//       setPresentMap({});
//       setReasonMap({});
//       toast.error('Something went wrong!!');
//     } finally {
//       setLoadingEmployees(false);
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad && attDate) {
//       GetEmployeesList(search, attDate);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectionData.vendor_id, selectionData.branch_id, attDate]);

//   const onHandleSearch = (e) => {
//     const val = e.target.value;
//     setSearch(val);
//     GetEmployeesList(val, attDate);
//   };

//   const onHandleDate = (e) => {
//     const val = e.target.value;

//     if (val > maxDate) {
//       toast.error('Future date is not allowed');
//       return;
//     }

//     setAttDate(val);
//     GetEmployeesList(search, val);
//   };

//   const setPresentStatus = (employeeId, isPresent) => {
//     setPresentMap((prev) => ({ ...prev, [employeeId]: isPresent }));

//     if (isPresent === true) {
//       setReasonMap((prev) => {
//         const copy = { ...prev };
//         delete copy[employeeId];
//         return copy;
//       });
//     }
//   };

//   const setEmployeeReason = (employeeId, reasonText) => {
//     setReasonMap((prev) => ({ ...prev, [employeeId]: reasonText }));
//   };

//   const handleSaveAttendance = async () => {
//     setError('');
//     setSuccessMsg('');
//     setAttendanceSummary(null);

//     if (!attDate) {
//       setError('Please select date.');
//       return;
//     }

//     if (attDate > maxDate) {
//       setError('Future date is not allowed.');
//       return;
//     }

//     if (!employees.length) {
//       setError('No employees to save.');
//       return;
//     }

//     const absentIds = employees
//       .map((e) => getEmployeeId(e))
//       .filter((id) => id != null && presentMap[id] === false);

//     const reasonsPayload = {};
//     absentIds.forEach((id) => {
//       const r = reasonMap[id];
//       if (r != null && r !== '') {
//         reasonsPayload[id] = r;
//       }
//     });

//     const payload = {
//       date: attDate,
//       startTime: startTime || null,
//       endtime: endTime || null,
//       absentEmployeeIds: absentIds,
//       reasons: reasonsPayload,
//     };

//     try {
//       setSaving(true);

//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       const config = {
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//         },
//       };

//       const response = await apiService.post(
//         `api/AttendanceMaster/save-employee?vendorId=${vendorId}&branchId=${branchId}`,
//         JSON.stringify(payload),
//         config,
//       );

//       if (response.status === true) {
//         setSuccessMsg(response.message || 'Attendance saved');
//         await fetchAttendanceSummary();
//       } else {
//         toast.error(response.message || 'Save failed');
//       }
//     } catch (err) {
//       console.log(err);
//       toast.error('Something went wrong!!');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const fetchAttendanceSummary = async () => {
//     try {
//       if (!attDate) {
//         toast.error('Please select date');
//         return;
//       }

//       if (attDate > maxDate) {
//         toast.error('Future date is not allowed');
//         return;
//       }

//       setViewLoading(true);

//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       const response = await apiService.get(
//         `api/AttendanceMaster/view-employee?date=${attDate}&vendorId=${vendorId}&branchId=${branchId}`,
//       );

//       if (response.status === true) {
//         setAttendanceSummary(response.data || null);
//       } else {
//         setAttendanceSummary(null);
//         toast.error(response.message || 'View failed');
//       }
//     } catch (err) {
//       console.log(err);
//       setAttendanceSummary(null);
//       toast.error('Something went wrong!!');
//     } finally {
//       setViewLoading(false);
//     }
//   };

//   const absenteesList = attendanceSummary?.absentees || [];

//   const totalPresentCount = employees.filter((e) => {
//     const id = getEmployeeId(e);
//     return id != null && presentMap[id] !== false;
//   }).length;

//   const totalAbsentCount = employees.filter((e) => {
//     const id = getEmployeeId(e);
//     return id != null && presentMap[id] === false;
//   }).length;

//   return (
//     <div className='container-fluid mt-3'>
//       <Row className='mb-2 align-items-end'>
//         <Col md='8'>
//           <h5 className='mb-1'>Employee Attendance</h5>
//         </Col>
//         <Col md='4' className='text-right'>
//           <Button color='secondary' size='sm' onClick={() => navigate(-1)}>
//             « Back
//           </Button>
//         </Col>
//       </Row>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box height-100-p pd-20 mb-20'>
//         <CardBody>
//           <Row className='mb-2'>
//             <Col md='4'>
//               <Label>Search</Label>
//               <Input
//                 placeholder='Search by employee name / profile'
//                 value={search}
//                 onChange={onHandleSearch}
//               />
//             </Col>

//             <Col md='4'>
//               <Label>Date</Label>
//               <Input
//                 type='date'
//                 value={attDate}
//                 max={maxDate}
//                 onChange={onHandleDate}
//               />
//             </Col>

//             <Col md='2'>
//               <Label>Start Time</Label>
//               <Input
//                 type='time'
//                 value={startTime}
//                 onChange={(e) => setStartTime(e.target.value)}
//               />
//             </Col>

//             <Col md='2'>
//               <Label>End Time</Label>
//               <Input
//                 type='time'
//                 value={endTime}
//                 onChange={(e) => setEndTime(e.target.value)}
//               />
//             </Col>
//           </Row>

//           <div className='d-flex justify-content-between align-items-center mb-2'>
//             <div>
//               <strong>Total:</strong> {employees.length} &nbsp; | &nbsp;
//               <strong>Present:</strong> {totalPresentCount} &nbsp; | &nbsp;
//               <strong>Absent:</strong> {totalAbsentCount}
//             </div>

//             <div className='d-flex gap-2'>
//               <Button
//                 color='success'
//                 onClick={handleSaveAttendance}
//                 disabled={saving || loadingEmployees}
//               >
//                 {saving ? (
//                   <>
//                     <Spinner size='sm' className='mr-2' /> Saving...
//                   </>
//                 ) : (
//                   'Save Attendance'
//                 )}
//               </Button>
//             </div>
//           </div>

//           {loadingReasons && (
//             <Alert color='info' className='py-2'>
//               Loading attendance reasons...
//             </Alert>
//           )}

//           {error && <Alert color='danger'>{error}</Alert>}
//           {successMsg && <Alert color='success'>{successMsg}</Alert>}

//           {loadingEmployees ? (
//             <div className='text-center'>
//               <Spinner /> Loading employees...
//             </div>
//           ) : (
//             <div className='table-responsive'>
//               <Table striped hover size='sm'>
//                 <thead>
//                   <tr>
//                     <th style={{ width: '60px' }}>#</th>
//                     <th>Employee Code</th>
//                     <th>Employee Name</th>
//                     <th>Designation</th>
//                     <th style={{ width: '220px' }}>Attendance</th>
//                     <th style={{ width: '220px' }}>Reason (if absent)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {employees.length > 0 ? (
//                     employees.map((emp, idx) => {
//                       const id =
//                         getEmployeeId(emp) ??
//                         `${idx}_${emp?.employeeCode ?? ''}`;

//                       const isAbsent = presentMap[id] === false;
//                       const reason = reasonMap[id] ?? '';

//                       return (
//                         <tr key={id}>
//                           <td>{idx + 1}</td>
//                           <td>{emp.employeeCode ?? '-'}</td>
//                           <td>{emp.employeeName ?? '-'}</td>
//                           <td>{emp.designationName ?? '-'}</td>

//                           <td>
//                             <div className='d-flex align-items-center gap-3'>
//                               <div className='form-check form-check-inline'>
//                                 <Input
//                                   type='radio'
//                                   name={`att_${id}`}
//                                   checked={isAbsent}
//                                   onChange={() => setPresentStatus(id, false)}
//                                 />
//                                 <Label className='ml-1 mb-0 text-danger'>
//                                   Absent
//                                 </Label>
//                               </div>

//                               <div className='form-check form-check-inline'>
//                                 <Input
//                                   type='radio'
//                                   name={`att_${id}`}
//                                   checked={!isAbsent}
//                                   onChange={() => setPresentStatus(id, true)}
//                                 />
//                                 <Label className='ml-1 mb-0 text-primary'>
//                                   Present
//                                 </Label>
//                               </div>
//                             </div>
//                           </td>

//                           <td>
//                             <Input
//                               type='select'
//                               value={reason}
//                               disabled={!isAbsent || loadingReasons}
//                               onChange={(e) =>
//                                 setEmployeeReason(id, e.target.value)
//                               }
//                             >
//                               <option value=''>
//                                 {loadingReasons
//                                   ? '-- Loading Reason --'
//                                   : '-- Select Reason --'}
//                               </option>

//                               {(reasonList || []).map((opt, i) => {
//                                 const text =
//                                   opt.multi_purpose_type ||
//                                   opt.multi_purpose_type_name ||
//                                   opt.name ||
//                                   '';

//                                 return (
//                                   <option key={opt.id ?? i} value={text}>
//                                     {text}
//                                   </option>
//                                 );
//                               })}
//                             </Input>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan='6' className='text-center'>
//                         No data available
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           )}

//           {attendanceSummary ? (
//             <div className='mt-3'>
//               <p className='mb-1'>
//                 <strong>Date:</strong>{' '}
//                 {attendanceSummary.date?.substring?.(0, 10) || '-'}
//                 &nbsp; | &nbsp;
//                 <strong>Start:</strong> {attendanceSummary.startTime || '-'}
//                 &nbsp; | &nbsp;
//                 <strong>End:</strong> {attendanceSummary.endTime || '-'}
//               </p>

//               {absenteesList.length > 0 ? (
//                 <>
//                   <h6 className='mt-3'>Absentees</h6>
//                   <Table striped hover size='sm'>
//                     <thead>
//                       <tr>
//                         <th style={{ width: '60px' }}>#</th>
//                         <th>Employee Name</th>
//                         <th>Reason</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {absenteesList.map((a, idx) => (
//                         <tr key={a.employeeId ?? idx}>
//                           <td>{idx + 1}</td>
//                           <td>{a.employeeName ?? '-'}</td>
//                           <td>{a.reason ?? '-'}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </>
//               ) : (
//                 <p className='text-muted mt-2'>No absentees.</p>
//               )}
//             </div>
//           ) : (
//             <p className='text-muted mt-2'>
//               No attendance summary found (or not yet saved).
//             </p>
//           )}
//         </CardBody>
//       </Card>
//     </div>
//   );
// };

// export default EmployeeAttendanceListPage;
//heena new
import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  Table,
  Spinner,
  Alert,
  Button,
} from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';

import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import VendorBranchSelector from '../../components/VendorBranchSelector';

const MULTI_PURPOSE_API_GET_ALL =
  'api/Multi_Purpose_Type_Master/Get_All_Multi_Purpose_Type_Master';

const EmployeeAttendanceListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const todayStr = new Date().toISOString().split('T')[0];
  const maxDate = new Date().toISOString().split('T')[0];

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [errorMessage, setErrorMessage] = useState({});
  const [search, setSearch] = useState('');
  const [employees, setEmployees] = useState([]);
  const [presentMap, setPresentMap] = useState({});
  const [reasonMap, setReasonMap] = useState({});
  const [reasonList, setReasonList] = useState([]);

  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [saving, setSaving] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [loadingReasons, setLoadingReasons] = useState(false);

  const [attendanceSummary, setAttendanceSummary] = useState(null);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const [attDate, setAttDate] = useState(todayStr);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  const getEmployeeId = (x) =>
    x?.employeeId ?? x?.employee_id ?? x?.EmployeeId ?? null;

  // Backend DateTime? ke liye date + time combine
  const buildDateTime = (date, time) => {
    if (!date || !time) return null;

    // time input value is HH:mm
    // backend DateTime? needs yyyy-MM-ddTHH:mm:ss
    return `${date}T${time}:00`;
  };

  // Agar API/location.state se full datetime aaye to input type="time" ke liye HH:mm banao
  const toTimeInputValue = (value) => {
    if (!value) return '';

    const strValue = String(value);

    // Case: "13:43"
    if (/^\d{2}:\d{2}$/.test(strValue)) {
      return strValue;
    }

    // Case: "13:43:00"
    if (/^\d{2}:\d{2}:\d{2}$/.test(strValue)) {
      return strValue.substring(0, 5);
    }

    // Case: "2026-05-04T13:43:00"
    if (strValue.includes('T')) {
      const timePart = strValue.split('T')[1];
      return timePart ? timePart.substring(0, 5) : '';
    }

    return '';
  };

  useEffect(() => {
    const st = location.state ?? {};
    const incomingDate = st?.date ?? todayStr;

    setAttDate(incomingDate > maxDate ? maxDate : incomingDate);
    setStartTime(toTimeInputValue(st?.startTime));
    setEndTime(toTimeInputValue(st?.endTime));

    setSelectionData({
      vendor_id: st?.vendorId ?? '',
      branch_id: st?.branchId ?? '',
    });

    if (Array.isArray(st?.reasonList) && st.reasonList.length > 0) {
      setReasonList(st.reasonList);
    }
  }, [location.state, todayStr, maxDate]);

  const Get_All_Multi_Purpose_Type_Master = async () => {
    try {
      setLoadingReasons(true);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(MULTI_PURPOSE_API_GET_ALL, config);

      if (response?.response?.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        const all = response.data || [];

        const reasons = all.filter(
          (item) =>
            String(item.multi_purpose_flag || '').toLowerCase() ===
            'attendancereason',
        );

        setReasonList(reasons);
      } else {
        setReasonList([]);
        toast.error(response.message || 'Unable to load attendance reasons');
      }
    } catch (error) {
      console.log(error);
      setReasonList([]);
      toast.error('SomeThing went wrong while loading reasons!!');
    } finally {
      setLoadingReasons(false);
    }
  };

  useEffect(() => {
    Get_All_Multi_Purpose_Type_Master();
  }, []);

  const GetEmployeesList = async (searchText = '', dateParam = null) => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';
      const usedDate = dateParam ?? attDate;

      setLoadingEmployees(true);
      setError('');
      setSuccessMsg('');
      setAttendanceSummary(null);

      const response = await apiService.get(
        `api/AttendanceMaster/GetEmployeesForAttendance?date=${usedDate}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (response.status === true) {
        const list = response.data || [];
        setEmployees(list);

        const pMap = {};
        const rMap = {};

        (list || []).forEach((e) => {
          const id = getEmployeeId(e);
          const present = e.isPresent ?? true;

          if (id != null) {
            pMap[id] = !!present;

            if (e.reason) {
              rMap[id] = e.reason;
            }
          }
        });

        setPresentMap(pMap);
        setReasonMap(rMap);
      } else {
        setEmployees([]);
        setPresentMap({});
        setReasonMap({});
        toast.error(response.message || 'Unable to load employees');
      }
    } catch (err) {
      console.log(err);
      setEmployees([]);
      setPresentMap({});
      setReasonMap({});
      toast.error('Something went wrong!!');
    } finally {
      setLoadingEmployees(false);
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad && attDate) {
      GetEmployeesList(search, attDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id, attDate]);

  const onHandleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    GetEmployeesList(val, attDate);
  };

  const onHandleDate = (e) => {
    const val = e.target.value;

    if (val > maxDate) {
      toast.error('Future date is not allowed');
      return;
    }

    setAttDate(val);
    GetEmployeesList(search, val);
  };

  const setPresentStatus = (employeeId, isPresent) => {
    setPresentMap((prev) => ({ ...prev, [employeeId]: isPresent }));

    if (isPresent === true) {
      setReasonMap((prev) => {
        const copy = { ...prev };
        delete copy[employeeId];
        return copy;
      });
    }
  };

  const setEmployeeReason = (employeeId, reasonText) => {
    setReasonMap((prev) => ({ ...prev, [employeeId]: reasonText }));
  };

  const handleSaveAttendance = async () => {
    setError('');
    setSuccessMsg('');
    setAttendanceSummary(null);

    if (!attDate) {
      setError('Please select date.');
      return;
    }

    if (attDate > maxDate) {
      setError('Future date is not allowed.');
      return;
    }

    if (!employees.length) {
      setError('No employees to save.');
      return;
    }

    const absentIds = employees
      .map((e) => getEmployeeId(e))
      .filter((id) => id != null && presentMap[id] === false);

    const reasonsPayload = {};
    absentIds.forEach((id) => {
      const r = reasonMap[id];

      if (r != null && r !== '') {
        reasonsPayload[id] = r;
      }
    });

    const payload = {
      date: attDate,
      startTime: buildDateTime(attDate, startTime),
      endtime: buildDateTime(attDate, endTime),
      absentEmployeeIds: absentIds,
      reasons: reasonsPayload,
    };

    try {
      setSaving(true);

      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await apiService.post(
        `api/AttendanceMaster/save-employee?vendorId=${vendorId}&branchId=${branchId}`,
        payload,
        config,
      );

      if (response.status === true) {
        setSuccessMsg(response.message || 'Attendance saved');
        await fetchAttendanceSummary();
      } else {
        toast.error(response.message || 'Save failed');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong!!');
    } finally {
      setSaving(false);
    }
  };

  const fetchAttendanceSummary = async () => {
    try {
      if (!attDate) {
        toast.error('Please select date');
        return;
      }

      if (attDate > maxDate) {
        toast.error('Future date is not allowed');
        return;
      }

      setViewLoading(true);

      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const response = await apiService.get(
        `api/AttendanceMaster/view-employee?date=${attDate}&vendorId=${vendorId}&branchId=${branchId}`,
      );

      if (response.status === true) {
        setAttendanceSummary(response.data || null);

        // Summary se time aaye to input fields me bhi set kar do
        if (response.data?.startTime) {
          setStartTime(toTimeInputValue(response.data.startTime));
        }

        if (response.data?.endTime) {
          setEndTime(toTimeInputValue(response.data.endTime));
        }
      } else {
        setAttendanceSummary(null);
        toast.error(response.message || 'View failed');
      }
    } catch (err) {
      console.log(err);
      setAttendanceSummary(null);
      toast.error('Something went wrong!!');
    } finally {
      setViewLoading(false);
    }
  };

  const absenteesList = attendanceSummary?.absentees || [];

  const totalPresentCount = employees.filter((e) => {
    const id = getEmployeeId(e);
    return id != null && presentMap[id] !== false;
  }).length;

  const totalAbsentCount = employees.filter((e) => {
    const id = getEmployeeId(e);
    return id != null && presentMap[id] === false;
  }).length;

  return (
    <div className='container-fluid mt-3'>
      <Row className='mb-2 align-items-end'>
        <Col md='8'>
          <h5 className='mb-1'>Employee Attendance</h5>
        </Col>

        <Col md='4' className='text-right'>
          <Button color='secondary' size='sm' onClick={() => navigate(-1)}>
            « Back
          </Button>
        </Col>
      </Row>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardBody>
          <Row className='mb-2'>
            <Col md='4'>
              <Label>Search</Label>
              <Input
                placeholder='Search by employee name / profile'
                value={search}
                onChange={onHandleSearch}
              />
            </Col>

            <Col md='4'>
              <Label>Date</Label>
              <Input
                type='date'
                value={attDate}
                max={maxDate}
                onChange={onHandleDate}
              />
            </Col>

            <Col md='2'>
              <Label>Start Time</Label>
              <Input
                type='time'
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
              />
            </Col>

            <Col md='2'>
              <Label>End Time</Label>
              <Input
                type='time'
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
              />
            </Col>
          </Row>

          <div className='d-flex justify-content-between align-items-center mb-2'>
            <div>
              <strong>Total:</strong> {employees.length} &nbsp; | &nbsp;
              <strong>Present:</strong> {totalPresentCount} &nbsp; | &nbsp;
              <strong>Absent:</strong> {totalAbsentCount}
            </div>

            <div className='d-flex gap-2'>
              <Button
                color='success'
                onClick={handleSaveAttendance}
                disabled={saving || loadingEmployees}
              >
                {saving ? (
                  <>
                    <Spinner size='sm' className='mr-2' /> Saving...
                  </>
                ) : (
                  'Save Attendance'
                )}
              </Button>

              <Button
                color='primary'
                onClick={fetchAttendanceSummary}
                disabled={viewLoading}
              >
                {viewLoading ? (
                  <>
                    <Spinner size='sm' className='mr-2' /> Loading...
                  </>
                ) : (
                  'View'
                )}
              </Button>
            </div>
          </div>

          {loadingReasons && (
            <Alert color='info' className='py-2'>
              Loading attendance reasons...
            </Alert>
          )}

          {error && <Alert color='danger'>{error}</Alert>}
          {successMsg && <Alert color='success'>{successMsg}</Alert>}

          {loadingEmployees ? (
            <div className='text-center'>
              <Spinner /> Loading employees...
            </div>
          ) : (
            <div className='table-responsive'>
              <Table striped hover size='sm'>
                <thead>
                  <tr>
                    <th style={{ width: '60px' }}>#</th>
                    <th>Employee Code</th>
                    <th>Employee Name</th>
                    <th>Designation</th>
                    <th style={{ width: '220px' }}>Attendance</th>
                    <th style={{ width: '220px' }}>Reason (if absent)</th>
                  </tr>
                </thead>

                <tbody>
                  {employees.length > 0 ? (
                    employees.map((emp, idx) => {
                      const id =
                        getEmployeeId(emp) ??
                        `${idx}_${emp?.employeeCode ?? ''}`;

                      const isAbsent = presentMap[id] === false;
                      const reason = reasonMap[id] ?? '';

                      return (
                        <tr key={id}>
                          <td>{idx + 1}</td>
                          <td>{emp.employeeCode ?? '-'}</td>
                          <td>{emp.employeeName ?? '-'}</td>
                          <td>{emp.designationName ?? '-'}</td>

                          <td>
                            <div className='d-flex align-items-center gap-3'>
                              <div className='form-check form-check-inline'>
                                <Input
                                  type='radio'
                                  name={`att_${id}`}
                                  checked={isAbsent}
                                  onChange={() => setPresentStatus(id, false)}
                                />
                                <Label className='ml-1 mb-0 text-danger'>
                                  Absent
                                </Label>
                              </div>

                              <div className='form-check form-check-inline'>
                                <Input
                                  type='radio'
                                  name={`att_${id}`}
                                  checked={!isAbsent}
                                  onChange={() => setPresentStatus(id, true)}
                                />
                                <Label className='ml-1 mb-0 text-primary'>
                                  Present
                                </Label>
                              </div>
                            </div>
                          </td>

                          <td>
                            <Input
                              type='select'
                              value={reason}
                              disabled={!isAbsent || loadingReasons}
                              onChange={(e) =>
                                setEmployeeReason(id, e.target.value)
                              }
                            >
                              <option value=''>
                                {loadingReasons
                                  ? '-- Loading Reason --'
                                  : '-- Select Reason --'}
                              </option>

                              {(reasonList || []).map((opt, i) => {
                                const text =
                                  opt.multi_purpose_type ||
                                  opt.multi_purpose_type_name ||
                                  opt.name ||
                                  '';

                                return (
                                  <option key={opt.id ?? i} value={text}>
                                    {text}
                                  </option>
                                );
                              })}
                            </Input>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan='6' className='text-center'>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}

          {attendanceSummary ? (
            <div className='mt-3'>
              <p className='mb-1'>
                <strong>Date:</strong>{' '}
                {attendanceSummary.date?.substring?.(0, 10) || '-'}
                &nbsp; | &nbsp;
                <strong>Start:</strong>{' '}
                {toTimeInputValue(attendanceSummary.startTime) || '-'}
                &nbsp; | &nbsp;
                <strong>End:</strong>{' '}
                {toTimeInputValue(attendanceSummary.endTime) || '-'}
              </p>

              {absenteesList.length > 0 ? (
                <>
                  <h6 className='mt-3'>Absentees</h6>

                  <Table striped hover size='sm'>
                    <thead>
                      <tr>
                        <th style={{ width: '60px' }}>#</th>
                        <th>Employee Name</th>
                        <th>Reason</th>
                      </tr>
                    </thead>

                    <tbody>
                      {absenteesList.map((a, idx) => (
                        <tr key={a.employeeId ?? idx}>
                          <td>{idx + 1}</td>
                          <td>{a.employeeName ?? '-'}</td>
                          <td>{a.reason ?? '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              ) : (
                <p className='text-muted mt-2'>No absentees.</p>
              )}
            </div>
          ) : (
            <p className='text-muted mt-2'>
              No attendance summary found (or not yet saved).
            </p>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default EmployeeAttendanceListPage;
